module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAxklEQVQokY3SO0oEURBA0dPSYGLqBnQHL1RUZDA0cwMDokZuwUZXoGg0SzCywVgxMpnagpgoiJ9EMDAYedBM1q+tsKhL3fpUbduuYIzbiHg0EDWucI7LlNIOjlH1YM8ZeMMIP/jGHRZ6gPcM7GMdZxHxi4eSVN0V3Q+5z4GU0ga+cIFd7BVmeM2uq7jBQZecFRrMqqZp/mszV1rEJqYR8TkIYIIXnKSUtrFWmOEjA8u4Rj7aErYKd3jKwFH3GocRkbd12uuDP0bBMZHXmK0yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon-liucheng.jpg
// module id = F2cP
// module chunks = 7 30 98